import {Badge, Button, Col, Modal, ProgressBar, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    setPrimerPaymentsAdminRequestData, setPrimerPosPrintVoucherPosition,
    setSelectedPrimerPos, setSelectedPrimerPosList
} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import Alert from "react-bootstrap/Alert";
import moment from "moment/moment";
import {getGreekCurrencyFormat, isEmpty, validateAFM} from "../../../../../_helpers/commonFunctions";
import axios from "axios";
import Input from "../../../../common/Input";
import {toast} from "react-toastify";
import Cloud from "../../Cloud/Cloud";
import {setAutoDir, setWasInMiniCloud} from "../../../../../_reducers/cloudSlice";
import CustomGauge from "./CustomGauge";
import {MdCancel} from "react-icons/md";
import {FaAmericanSignLanguageInterpreting, FaLock, FaUnlock} from "react-icons/fa";
import {RiContractFill} from "react-icons/ri";
import {PrimerPosConfigurationModal} from "./primer-pos-configuration-modal";
import {IoCloudOffline} from "react-icons/io5";
import {PiPlugsConnectedLight} from "react-icons/pi";
import PrimerPosSunmiInfoModal from "./primer-pos-sunmi-info-modal";
import DateBox from "../../../../primer/DateBox";
import Dropdown from "../../../../primer/Dropdown";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import UnlockPosModal from "./unlock-pos-modal";
import PrimerPosVoucherMultipleSerialsModal from "./primer-pos-voucher-multiple-serials-modal";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import PrimerPosLogsModal from "./primer-pos-logs-modal";
import {openClientLocal, openTabByType} from "../../../../../_helpers/tabOpeners";

const PrimerPosModal = () => {
    const dispatch = useDispatch();
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const selectedPrintVoucherPosition = useSelector((state) => state.CLIENTS_DATA.primerPosPrintVoucherPosition);
    const primerPaymentsRequestData = useSelector((state) => state.CLIENTS_DATA.reportPrimerPaymentsAdminRequestData);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const isMobileScreen = useMediaQuery("(max-width: 768px)");
    const [client, setClient] = useState(null);
    const [onlineStatus, setOnlineStatus] = useState(false);
    const [contractLoader, setContractLoader] = useState(false);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [sunmiLoader, setSunmiLoader] = useState(false);
    const [voucherLoader, setVoucherLoader] = useState(false);
    const [trackingLoader, setTrackingLoader] = useState(false);
    const [sunmiDeviceInfo, setSunmiDeviceInfo] = useState(null);
    const [primerPosConfigurationModal, setPrimerPosConfigurationModal] = useState(false);
    const [posReleaseModal, setPosReleaseModal] = useState(false);
    const [posRevokeModal, setPosRevokeModal] = useState(false);
    const [posEnableModal, setPosEnableModal] = useState(false);
    const [posRevokeEnableLoader, setPosRevokeEnableLoader] = useState(false);
    const [posReleaseLoader, setPosReleaseLoader] = useState(false);
    const [deleteVoucherModal, setDeleteVoucherModal] = useState(false);
    const [deleteVoucherLoader, setDeleteVoucherLoader] = useState(false);
    const [unlockPosModal, setUnlockPosModal] = useState(false);
    const [posLogsModal, setPosLogsModal] = useState(false);
    const [editWarehousePosition, setEditWarehousePosition] = useState(false);
    const [disableSimCheckbox, setDisableSimCheckbox] = useState(false);
    const [popEditWarehousePosition, setPopEditWarehousePosition] = useState("");
    const [multiplePos, setMultiplePos] = useState([]);
    const [customEmail, setCustomEmail] = useState("");

    const totalSteps = selectedPos ? selectedPos?.configurationSteps?.length : 0;
    const completedSteps = selectedPos ? selectedPos?.configurationSteps?.filter((el) => el.status === "completed")?.length : 0;

    const leaseTermOptions = [
        {value: "1", label: "1 Έτος"},
        {value: "2", label: "2 Έτη"},
        {value: "3", label: "3 Έτη"},
    ];

    const positionOptions = [
        {value: "1", label: "Αρχή Σελίδας"},
        {value: "2", label: "Κέντρο Σελίδας"},
        {value: "3", label: "Τέλος Σελίδας"},
    ];

    const statusOptions = [
        {value: "notAvailable", label: "Μη Διαθέσιμο"},
        {value: "waitingStock", label: "Αναμένεται Συσκευή"},
        {value: "available", label: "Διαθέσιμο"},
        {value: "purchased", label: "Δεσμευμένο"},
        {value: "ready", label: "Προς αποστολή"},
        {value: "shipped", label: "Απεσταλμένο"},
        {value: "arrived", label: "Παρελήφθη"}
    ];

    const contractStatusOptions = [
        {value: "noIssue", label: "Δεν έχει εκδοθεί", per: 0},
        {value: "issue", label: "Αναμένεται υπογραφή", per: 50},
        {value: "signed", label: "Υπεγράφη", per: 100},
    ];


    useEffect(() => {
        if(!isEmpty(selectedPos) && selectedPos?.client) {
            axios.get(process.env.REACT_APP_API_URL2 + "/callcenter/get-client-by-id", {
                headers: {"Content-Type": "application/json"},
                params: {clientId: selectedPos?.client}
            }).then((res) => {
                if(res.data.status === "200") {
                    setClient(res.data.data);
                    setCustomEmail(res.data.data?.email);
                    if(selectedPos?.serialNumber) {
                        dispatch(setWasInMiniCloud(true));
                        dispatch(setAutoDir(`/ERP/Πελάτες/${res.data.data._id}/POS_Contract-${selectedPos.serialNumber}`));
                    }
                } else {
                    setClient(null);
                    setCustomEmail("");
                }
            }).catch(() => {
                setClient(null);
                setCustomEmail("");
            })
        } else {
            setClient(null);
            setCustomEmail("");
        }
    }, [selectedPos?._id, selectedPos?.client]);

    useEffect(() => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            checkOnlineStatus();
            getSunmiDeviceInfo(true);
        } else {
            setOnlineStatus(false);
        }
        setMultiplePos([]);
        setEditWarehousePosition(false);
        setDisableSimCheckbox(!isEmpty(selectedPos?.simId));
    }, [selectedPos?._id]);

    useEffect(() => {
        if(selectedPos?.printVoucher === true) {
            printAcsVoucher();
        }
    }, [selectedPos?.printVoucher]);


    const popEdit = (warehousePosition) => {
        if(selectedPos?.status === "waitingStock") {
            return toast.error("Δεν είναι διαθέσιμη η αλλαγή θέσης αποθήκης σε συσκευή που αναμένεται!");
        }
        if(selectedPos?.status === "shipped" || selectedPos?.status === "arrived") {
            return toast.error("Δεν είναι διαθέσιμη η αλλαγή θέσης αποθήκης σε συσκευή που έχει αποχωρήσει από την αποθήκη!");
        }
        setEditWarehousePosition(true);
        setPopEditWarehousePosition(warehousePosition);
    }
    const savePopEdit = () => {
        if(!isEmpty(selectedPos)) {
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-update-warehouse-position", {_id: selectedPos._id, warehousePosition: !isEmpty(popEditWarehousePosition) ? popEditWarehousePosition : selectedPos?.warehousePosition}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.data));
                    toast.success(res.data.message);
                    setPopEditWarehousePosition("");
                    setEditWarehousePosition(false);
                } else {
                    toast.error(res.data.message);
                }
            }).catch((error) => {
                toast.error(error);
                console.log(error);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!")
        }
    }
    const cancelPopEdit = () => {
        setEditWarehousePosition(false);
        setPopEditWarehousePosition(selectedPos?.warehousePosition);
    }
    const handlePopEditChange = (e) => {
        if(editWarehousePosition) {
            setPopEditWarehousePosition(e.target.value.trim());
        }
    }

    const checkOnlineStatus = (showToast = false) => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setSunmiLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", {_id: selectedPos?._id, action: "checkStatus"}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSunmiLoader(false);
                if(res.data.status === "200") {
                    setOnlineStatus(res.data?.data);
                    if(showToast) toast.success(res.data.message);
                } else {
                    setOnlineStatus(false);
                    if(showToast) toast.error(res.data.message);
                }
            }).catch(() => {
                if(showToast) toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setOnlineStatus(false);
                setSunmiLoader(false);
            })
        }
    }

    const getSunmiDeviceInfo = (offlineInfo = false) => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setSunmiLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", {_id: selectedPos?._id, action: "getDeviceInfo", isOnline: offlineInfo ? false : onlineStatus}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSunmiLoader(false);
                    if(res.data.status === "200") {
                        if(!offlineInfo) {
                            setSunmiDeviceInfo(res.data?.data);
                            toast.success(res.data.message);
                        }
                        if(!isEmpty(res.data?.object)) {
                            dispatch(setSelectedPrimerPos(res.data.object));
                        }
                    } else {
                        setSunmiDeviceInfo(null);
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSunmiDeviceInfo(null);
                setSunmiLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }


    const handleOnChange = (e, type = "default", ddname = '') => {
        let name;
        let value;
        if (type === 'dd') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e ? moment(e).format("DD/MM/YYYY") : "";
            name = ddname;
        } else if (type === "dtb") {
            value = e ? moment(e).toDate() : "";
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === 'ac') {
            value = e.target.value;
            name = ddname;
        } else if (type === "acb") {
            value = e.target.value;
            name = ddname;
        } else if (type === "cb") {
            value = e.target.checked;
            name = ddname;
        } else if(type === "inputNumber") {
            value = e.target.value.replace(/[^0-9]/g, '');
            name = e.target.name;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let editSelectedPos = Object.assign({}, selectedPos);
        editSelectedPos[name] = value;
        dispatch(setSelectedPrimerPos(editSelectedPos));
    }

    const issueContract = () => {
        if(!isEmpty(selectedPos) && !isEmpty(selectedPos?.representativeName) && !isEmpty(selectedPos?.leaseTerm) && !isEmpty(selectedPos?.representativeSurname) && !isEmpty(selectedPos?.representativeVatNumber)) {
            if(!validateAFM(selectedPos.representativeVatNumber)) {
                return toast.error("Το Α.Φ.Μ. Εκπροσώπου είναι λάθος. Παρακαλώ ξαναπροσπαθήστε.");
            }
            setContractLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/issue-primer-pos-contract",
                {
                    _id: selectedPos?._id,
                    representativeName: selectedPos.representativeName,
                    representativeSurname: selectedPos.representativeSurname,
                    representativeVatNumber: selectedPos.representativeVatNumber,
                    leaseTerm: selectedPos.leaseTerm
                },
                {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.object));
                    toast.success(res.data.message);
                    const binaryString = atob(res.data.data);
                    const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
                    const blob = new Blob([byteArray], { type: "application/pdf" });
                    let blobUrl = URL.createObjectURL(blob);
                    blobUrl += "#navpanes=0&view=Fit";
                    window.open(blobUrl, "_blank");
                } else {
                    toast.error(res.data.message);
                }
                setContractLoader(false);
            }).catch((error) => {
                toast.error(error);
                console.log(error);
                setContractLoader(false);
            })
        } else {
            toast.error("Παρακαλώ εισάγετε όλα τα στοιχεία του νομίμου εκπροσώπου!");
        }
    }

    const sendContractNotification = () => {
        if(!isEmpty(selectedPos)) {
            setUploadLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-send-contract", {_id: selectedPos._id}, {headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if(res.data.status === "200") {
                    dispatch(setSelectedPrimerPos(res.data.data));
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setUploadLoader(false);
            }).catch((error) => {
            toast.error(error);
            console.log(error);
            setUploadLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά. Παρακαλώ ξαναπροσπαθήστε!")
        }
    }

    const createAcsVoucher = (checkMultiple = true, multipleSerials = []) => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            if(selectedPos?.contractStatus !== "signed") {
                return toast.error("Παρακαλώ ολοκληρώστε πρώτα την διαδικασία υπογραφής συμβολαίου για έκδοση ACS Voucher!");
            }
            if(!(totalSteps > 0 && completedSteps === totalSteps)) {
                return toast.error("Παρακαλώ ολοκληρώστε πρώτα την διαδικασία παραμετροποίησης για έκδοση ACS Voucher!");
            }
            setVoucherLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-acs-voucher", {_id: selectedPos?._id, checkMultiple: checkMultiple, multipleSerials: multipleSerials, action: "create", quantity: "1", shippingDate: moment(selectedPos?.shippingDate).isValid() ? moment(selectedPos?.shippingDate).toDate() : moment().add("1", "day").toDate()}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setVoucherLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        dispatch(setSelectedPrimerPos({...res.data.data, printVoucher: true, position: selectedPos?.position || "1"}));
                    } else if(res.data?.status ===  "423") {
                        setMultiplePos(res.data.sameSerials);
                        toast.info(res.data.message);
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setVoucherLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }


    const printAcsVoucher = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            if(isEmpty(selectedPos?.shippingData?.acsVoucher)) {
                dispatch(setSelectedPrimerPos({...selectedPos, printVoucher: false}));
                return toast.error("Δεν βρέθηκε ACS Voucher για εκτύπωση");
            }
            setVoucherLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-acs-voucher", {_id: selectedPos?._id, action: "print", acsVoucher: selectedPos.shippingData.acsVoucher, position: String(selectedPrintVoucherPosition) }, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setVoucherLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        printBase64Pdf(res.data.data);
                        dispatch(setPrimerPosPrintVoucherPosition(res.data?.printVoucherPosition || 1));
                        dispatch(setSelectedPrimerPos({...res.data.object, printVoucher: false}));
                    } else {
                        dispatch(setSelectedPrimerPos({...selectedPos, printVoucher: false}));
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                dispatch(setSelectedPrimerPos({...selectedPos, printVoucher: false}));
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setVoucherLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const deleteAcsVoucher = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            if(isEmpty(selectedPos?.shippingData?.acsVoucher)) {
                return toast.error("Δεν βρέθηκε ACS Voucher για ακύρωση");
            }
            setDeleteVoucherLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-acs-voucher", {_id: selectedPos?._id, action: "delete", acsVoucher: selectedPos.shippingData.acsVoucher}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setDeleteVoucherLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        dispatch(setSelectedPrimerPos(res.data.data));
                        setDeleteVoucherModal(false);
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setDeleteVoucherLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const printBase64Pdf = (base64String) => {
        const blob = new Blob([Uint8Array.from(atob(base64String), c => c.charCodeAt(0))], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        iframe.onload = () => {
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 100);
        };
        document.body.appendChild(iframe);
    };

    const releasePos = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setPosReleaseLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-change-status", {_id: selectedPos?._id, action: "release", disableSim : disableSimCheckbox}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setPosReleaseLoader(false);
                    if(res.data.status === "200") {
                        setPosReleaseModal(false);
                        toast.success(res.data.message);
                        dispatch(setSelectedPrimerPos(res.data.data));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setPosReleaseLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const revokePos = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setPosRevokeEnableLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-change-status", {_id: selectedPos?._id, action: "revoke", disableSim : disableSimCheckbox}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setPosRevokeEnableLoader(false);
                    if(res.data.status === "200") {
                        setPosRevokeModal(false);
                        toast.success(res.data.message);
                        dispatch(setSelectedPrimerPos(res.data.data));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setPosRevokeEnableLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const enablePos = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setPosRevokeEnableLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-change-status", {_id: selectedPos?._id, action: "enable"}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setPosRevokeEnableLoader(false);
                    if(res.data.status === "200") {
                        setPosEnableModal(false);
                        toast.success(res.data.message);
                        dispatch(setSelectedPrimerPos(res.data.data));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setPosRevokeEnableLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const navigateToClient = (innerTab) => {
        dispatch(openClientLocal(client, TABS_DATA, innerTab));
    }

    const navigateToPrimerPayments = (innerTab) => {
        dispatch(setPrimerPaymentsAdminRequestData({...primerPaymentsRequestData, subscriptionId: selectedPos?.subscriptionId, dateFrom: "01/01/2022", dateTo: moment().add("2", "years").format("DD/MM/YYYY"), firstLoad: false, forceRefresh: true}));
        dispatch(openTabByType("reports-primer-payments-admin", TABS_DATA, innerTab));
    }

    const handleOpenAcsList = (acsListId) => {
        axios.post(process.env.REACT_APP_API_URL2 + `/client/get-acs-list-data`, {acsListId: acsListId}, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if(res.data.status === "200") {
                dispatch(setSelectedPrimerPosList(res.data.data));
                dispatch(openTabByType("primer-pos-search-list", TABS_DATA));
            } else {
                toast.error("Πρόβλημα κατά το άνοιγμα της Λίστας Αποστολής.")
            }
        }).catch((err) => {
            console.log(err);
        })
    }


    const sendTrackingEmail = () => {
        if(!isEmpty(client?.email) || !isEmpty(customEmail)) {
            setVoucherLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-send-tracking-email", {_id: selectedPos?._id, email: !isEmpty(customEmail) ? customEmail : client.email}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setVoucherLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setVoucherLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const openTrackingUrl = () => {
        if(!isEmpty(selectedPos) && !isEmpty(selectedPos?.orderId)) {
            setTrackingLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-get-tracking-url", {_id: selectedPos?._id}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setTrackingLoader(false);
                    if(res.data.status === "200" && res.data?.data) {
                        window.open(res.data.data, "_blank");
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setTrackingLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }



    return (
        <React.Fragment>
        <Modal backdrop={"static"} className="themeModalVeryBig" show={!isEmpty(selectedPos)} onHide={() => dispatch(setSelectedPrimerPos(null))}>
            <Modal.Header style={{padding: "0.5rem"}} closeButton>
                <Modal.Title>{`Διαχείριση POS (${selectedPos?.productName}: ${selectedPos?.serialNumber})`}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{padding: "0.1rem 0.5rem"}}>
                <div style={{maxHeight: isMobileScreen ? "60vh" : "100vh", overflowY: 'auto', width: "100%", overflowX: isMobileScreen? 'auto' : 'hidden', padding: "2px"}}>
                    <div className="d-flex justify-content-between">
                        <p style={{flex: 1}} className="text-muted mb-1"><i>Στοιχεία Συσκευής:</i></p>
                        <p style={{flex: 1}} className="text-muted mb-1 ml-4"><i>Στοιχεία Πελάτη:</i></p>
                        <p style={{flex: 1}} className="text-muted mb-1 ml-4"><i>Στοιχεία Συνδρομής Συσκευής:</i></p>
                    </div>
                    <Row>
                        <Col md={4}>
                            <Alert style={{padding: "0.5rem 1rem"}} variant={"secondary"}>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Σειριακός Αριθμός:</span>
                                    <span style={{textAlign: 'end'}}>{selectedPos?.serialNumber}</span>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Τύπος Συσκευής:</span>
                                    <span style={{textAlign: 'end'}}>{`${selectedPos?.productName} (Βάρος: ${selectedPos?.productWeight} kg)`}</span>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center fw-bold">
                                    <span style={{textAlign: 'start'}}>Θέση Αποθήκης:</span>
                                    {selectedPos?.status === "shipped" ? (
                                        <span style={{textAlign: 'end'}}>{selectedPos?.warehousePosition}</span>
                                    ) : (
                                        <div className="d-flex align-items-center justify-content-end">
                                            <input
                                                className="ml-1"
                                                name="editWarehousePosition"
                                                value={!isEmpty(popEditWarehousePosition) ? popEditWarehousePosition : selectedPos?.warehousePosition}
                                                style={{height: "23px", fontSize: "14px", width: "30%", fontWeight: 'bold', textAlign: 'center'}}
                                                disabled={!editWarehousePosition}
                                                onChange={(e) => handlePopEditChange(e)}
                                            />
                                            {!editWarehousePosition && (
                                                <Badge bg="secondary" className="ml-1" style={{cursor: "pointer", padding: "2px"}} onClick={() => popEdit(popEditWarehousePosition)}>
                                                    <img src={"assets/images/callcenter/pencil.png"} style={{width: "16px", height: "16px"}} alt={"Pencil"} />
                                                </Badge>
                                            )}
                                            {editWarehousePosition && (
                                                <>
                                                    <Badge bg="success" className="ml-1" style={{cursor: "pointer", padding: "2px"}} onClick={() => savePopEdit(popEditWarehousePosition)}>
                                                        <img src={"assets/images/callcenter/save.png"} style={{width: "16px", height: "16px"}} alt={"Save"} />
                                                    </Badge>
                                                    <Badge bg="danger" className="ml-1" style={{cursor: "pointer", padding: "2px"}} onClick={() => cancelPopEdit()}>
                                                        <img src={"assets/images/callcenter/cancel.png"} style={{width: "16px", height: "16px"}} alt={"Cancel"} />
                                                    </Badge>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Κατάσταση:</span>
                                    <span style={{textAlign: 'end'}}>{statusOptions.find((el) => el.value === selectedPos?.status)?.label}</span>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Ημερομηνία Εισαγωγής:</span>
                                    <span style={{textAlign: 'end'}}>{`${moment(selectedPos?.created_at).format("DD/MM/YYYY HH:mm:ss")} από ${selectedPos?.createdBy || ""}`}</span>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Κατάσταση Σύνδεσης:</span>
                                    <div style={{alignContent: 'center', textAlign: 'center'}}>
                                        <span className={"mr-1"} style={{color: onlineStatus ? "green" : "red"}}>{`${onlineStatus ? "Συνδεδεμένο" : "Αποσυνδεδεμένο"}`} {!onlineStatus ? <IoCloudOffline className={"mb-1"} size={17} color={"red"} /> : <PiPlugsConnectedLight className={"mb-1"} size={20} color={"green"} />}</span>
                                        <span className={"ml-1"} style={{color: selectedPos?.lockStatus !== "locked" ? "green" : "red"}}>{`${selectedPos?.lockStatus !== "locked" ? "Ξεκλείδωτο" : "Κλειδωμένο"}`} {selectedPos?.lockStatus !== "locked" ? <FaUnlock className={"mb-1"} size={15} color={"green"} /> : <FaLock className={"mb-1"} size={15} color={"red"} />}</span>
                                    </div>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center mt-1">
                                    <Button style={{padding: "7px"}} disabled={sunmiLoader || selectedPos?.status === "waitingStock"} variant="primary" onClick={() => checkOnlineStatus(true)}>
                                        {"Έλεγχος Σύνδεσης "} {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                    <Button style={{padding: "7px"}} disabled={sunmiLoader || selectedPos?.status === "waitingStock"} variant="primary" onClick={() => getSunmiDeviceInfo()}>
                                        {"Διαχείριση Συσκευής "} {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                    {selectedPos?.lockStatus === "locked" && (
                                        <Button style={{padding: "7px"}} variant="primary" onClick={() => setUnlockPosModal(true)}>
                                            Ξεκλείδωμα Συσκευής
                                        </Button>
                                    )}
                                </div>
                            </Alert>
                        </Col>
                        <Col md={4}>
                            <Alert style={{padding: "0.5rem 1rem"}} variant={"secondary"}>
                                {!isEmpty(client) && (
                                    <React.Fragment>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                            <span style={{textAlign: 'start'}}>Όνομα Πελάτη:</span>
                                            <span style={{textAlign: 'end'}}>{client?.name}</span>
                                        </div>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                            <span style={{textAlign: 'start'}}>Α.Φ.Μ.:</span>
                                            <span style={{textAlign: 'end'}}>{client?.vatNumber}</span>
                                        </div>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                            <span style={{textAlign: 'start'}}>Τηλέφωνο:</span>
                                            <span style={{textAlign: 'end'}}>{client?.phone}</span>
                                        </div>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                            <span style={{textAlign: 'start'}}>e-mail:</span>
                                            <span style={{textAlign: 'end'}}>{client?.email}</span>
                                        </div>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between fw-bold">
                                            <span style={{textAlign: 'start'}}>Διεύθυνση:</span>
                                            <span style={{textAlign: 'end'}}>{`${client?.address}, ${client?.city}, ${client?.postalCode}`}</span>
                                        </div>
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center mt-1">
                                            <Button style={{padding: "7px"}} disabled={isEmpty(client)} variant="primary" onClick={() => navigateToClient(1)}>
                                                Εμφάνιση Καρτέλας Πελάτη
                                            </Button>
                                            <Button style={{padding: "7px"}} variant="primary" onClick={() => navigateToClient(7)}>
                                                Εμφάνιση Συνδρομών Πελάτη
                                            </Button>
                                        </div>
                                    </React.Fragment>
                                )}
                            </Alert>
                        </Col>
                        <Col md={4}>
                            <Alert style={{padding: "0.5rem 1rem"}} variant={"secondary"}>
                                {(!isEmpty(client) && selectedPos?.status !== "available") && (
                                <React.Fragment>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span style={{textAlign: 'start'}} className={'fw-bold'}>Ημερομηνία Αγοράς:</span>
                                        <span style={{textAlign: 'end'}}>{moment(selectedPos?.paidDate).format("DD/MM/YYYY HH:mm:ss")}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span style={{textAlign: 'start'}} className={'fw-bold'}>Αριθμός Συνδρομής:</span>
                                        <span style={{textAlign: 'end'}}>{`${selectedPos?.subscriptionId} (${selectedPos?.orderId || ""})`}</span>
                                    </div>
                                    {selectedPos?.orderCoupons?.length > 0 && (
                                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Κουπόνια Αγοράς:</span>
                                            <span style={{textAlign: 'end'}}>{selectedPos.orderCoupons.join(", ")}</span>
                                        </div>
                                    )}
                                    {!isEmpty(client?.subscriptions?.find((el) => String(el.link_subscription_id) === String(selectedPos?.subscriptionId))) &&
                                    (() => {
                                        const subObject = client?.subscriptions?.find((el) => String(el.link_subscription_id) === String(selectedPos?.subscriptionId));
                                        return (
                                            <React.Fragment>
                                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Κατάσταση Συνδρομής:</span>
                                                    <span style={{textAlign: 'end'}}>{subObject.status === "active" ? "Ενεργή" : "Ανενεργή"}</span>
                                                </div>
                                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Τιμή Συνδρομής:</span>
                                                    <span style={{textAlign: 'end'}}>{`${getGreekCurrencyFormat(subObject.subscription_real_price)} κάθε ${subObject.billing_period_in_months} ${subObject.billing_period_in_months === 1 ? "μήνα" : "μήνες"}`}</span>
                                                </div>
                                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>{subObject.status === "active" ? "Ημερομηνία Επόμενης Πληρωμής" : "Ημερομηνία Λήξης"}</span>
                                                    <span style={{textAlign: 'end'}}>{moment(subObject?.endDate).format("DD/MM/YYYY HH:mm")}</span>
                                                </div>
                                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>SKU Προϊόντος:</span>
                                                    <span style={{textAlign: 'end'}}>{subObject.sku}</span>
                                                </div>
                                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center mt-1">
                                                    <Button style={{padding: "7px"}} variant="primary" onClick={() => navigateToPrimerPayments()}>
                                                        Εμφάνιση Πράξεων Συνδρομής
                                                    </Button>
                                                    <Button style={{padding: "7px"}} variant="primary" onClick={() => window.open(`${process.env.REACT_APP_MASTER_SOFTWARE}?serialNumber=${selectedPos.serialNumber}`)}>
                                                        Άνοιγμα Υποστήριξης e-Ταμειακής
                                                    </Button>
                                                </div>
                                            </React.Fragment>
                                        )})()}
                                </React.Fragment>
                                )}
                            </Alert>
                        </Col>
                    </Row>
                    <hr style={{marginTop: "0px", marginBottom: "0.3rem"}} />
                    <p className="text-muted" style={{marginBottom: "0px"}}><i>Στοιχεία Συμβολαίου:</i></p>
                    {(!isEmpty(client) && selectedPos?.status !== "waitingStock") ? (
                        <React.Fragment>
                            <Row className="align-items-center">
                                <Col md={2}>
                                    <Input
                                        label={"Όνομα Νομίμου Εκπροσώπου"}
                                        name={"representativeName"}
                                        disabled={selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"}
                                        placeholder={"Εισάγετε Όνομα Νομίμου Εκπροσώπου"}
                                        type={"text"}
                                        required={true}
                                        value={selectedPos?.representativeName}
                                        onChange={(e) => handleOnChange(e, "input", "providedServiceCategoryOther")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        label={"Επώνυμο Νομίμου Εκπροσώπου"}
                                        name={"representativeSurname"}
                                        disabled={selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"}
                                        placeholder={"Εισάγετε Επώνυμο Νομίμου Εκπροσώπου"}
                                        type={"text"}
                                        required={true}
                                        value={selectedPos?.representativeSurname}
                                        onChange={(e) => handleOnChange(e, "input", "representativeSurname")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        label={"Α.Φ.Μ. Νομίμου Εκπροσώπου"}
                                        name={"representativeVatNumber"}
                                        disabled={selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"}
                                        placeholder={"Εισάγετε Α.Φ.Μ. Νομίμου Εκπροσώπου"}
                                        type={"text"}
                                        required={true}
                                        value={selectedPos?.representativeVatNumber}
                                        onChange={(e) => handleOnChange(e, "inputNumber", "representativeVatNumber")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Dropdown
                                        className="mt-1"
                                        name={"leaseTerm"}
                                        label={"Διάρκεια Μίσθωσης εξοπλισμού"}
                                        disabled={selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"}
                                        required={true}
                                        key={Math.random()}
                                        defaultValue={leaseTermOptions.find((el) => el.value === selectedPos?.leaseTerm)}
                                        options={leaseTermOptions}
                                        onChange={(e) => handleOnChange(e, "dd", "leaseTerm")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Button disabled={contractLoader || selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"} className={"mt-4"} variant="primary" onClick={() => issueContract()}>
                                        Έκδοση Συμβολαίου
                                        {contractLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                                <Col md={2}>
                                    <Button disabled={uploadLoader || selectedPos?.status === "available" || selectedPos?.contractStatus === "signed"} style={{padding: "9px"}} className={"mt-4"} variant="primary" onClick={() => sendContractNotification()}>
                                        Ενημέρωση και Αποστολή Ειδοποίησης
                                        {uploadLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>
                            <Row className={"mt-2"}>
                                <Col md={4}>
                                    <p className="text-muted mb-1"><i>Ενέργειες Αρχείου:</i></p>
                                    <Cloud primerPos={true} miniCloud={true} />
                                </Col>
                                <Col md={4} className="justify-content-center align-items-center">
                                    <p className="text-muted mb-0"><i>Κατάσταση Συμβολαίου:</i></p>
                                    <CustomGauge
                                        value={contractStatusOptions.find((el) => el.value === selectedPos?.contractStatus)?.per || 0}
                                        min={0}
                                        max={100}
                                        startAngle={-110}
                                        endAngle={110}
                                        size={190}
                                        strokeWidth={24}
                                        color="#76AEB7"
                                        backgroundColor="#f5f5f5">
                                        <div className="d-flex flex-column align-items-center">
                                            {selectedPos?.contractStatus === "noIssue" ? <MdCancel color={"rgb(237, 66, 66)"} size={40} /> : selectedPos?.contractStatus === "issue" ? <FaAmericanSignLanguageInterpreting  size={40} color={"orange"} /> : <RiContractFill color={"green"} size={40} />}
                                            <span style={{
                                                textAlign: 'center',
                                                fontSize: "15px",
                                                color: selectedPos?.contractStatus === "noIssue" ? "rgb(237, 66, 66)" : selectedPos?.contractStatus === "issue" ? "orange" : "green"
                                            }} className={`fw-bold ${selectedPos?.contractStatus !== "signed" ? "w-50" : "w-100" }`}>
                                                {selectedPos?.contractStatus === "noIssue" ? "Δεν έχει αποσταλεί" : selectedPos?.contractStatus === "issue" ? "Αναμένεται υπογραφή" : "Υπεγράφη"}
                                            </span>
                                        </div>
                                    </CustomGauge>
                                </Col>
                                <Col md={4}>
                                    <p className="text-muted mb-0"><i>Αρχείο Καταγραφής Συμβολαίου:</i></p>
                                    <div style={{ maxHeight: '17vh', overflowY: 'auto', borderBottom: '1px black solid' }}>
                                        <table style={{position: 'sticky', top: "0px", width: "100%"}} className={"simpleClassicTable"}>
                                            <colgroup>
                                                <col span={1} style={{width: "30%"}}></col>
                                                <col span={1} style={{width: "40%"}}></col>
                                                <col span={1} style={{width: "30%"}}></col>
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th>Ημερομηνία</th>
                                                <th>Ενέργεια</th>
                                                <th>Χρήστης</th>
                                            </tr>
                                            </thead>
                                        </table>
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <tbody>
                                        {(selectedPos?.contractLogs || [])
                                            .slice()
                                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                                            .map((row, idx) => (
                                                <tr key={`fsHistory-${idx}`}>
                                                    <td>{moment(row.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                                    <td>{row.description}</td>
                                                    <td>{row.user}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    ) : (
                        <Alert variant={"secondary"} style={{padding: "10px"}}>
                            <div style={{fontSize: "13px"}}  className="d-flex justify-content-center">
                                <span className={"fw-bold"} style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Δεν είναι διαθέσιμες οι λειτουργίες Συμβολαίου σε μη δεσμευμένη συσκευή από πελάτη.</span><br />
                            </div>
                        </Alert>
                    )}
                    <hr style={{marginTop: "0px", marginBottom: "0.3rem"}} />
                    <p className="text-muted mb-0"><i>Διαδικασία Παραμετροποίησης:</i></p>
                    {(selectedPos?.status !== "waitingStock") ? (
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className="progress-wrapper position-relative my-2" style={{ flexGrow: 1, marginRight: '1rem' }}>
                                    <ProgressBar
                                        now={Math.round((completedSteps / totalSteps) * 100)}
                                        animated
                                        striped
                                        style={{ height: '30px' }}
                                        className={Math.round((completedSteps / totalSteps) * 100) === 100 ? "custom-progress-completed" : "custom-progress-pending"}
                                    />
                                    <div className="centered-label">
                                        <span>{completedSteps} / {totalSteps} βήματα ολοκληρώθηκαν</span>
                                    </div>
                                </div>
                                <Button
                                    variant="primary"
                                    onClick={() => setPrimerPosConfigurationModal(true)}>
                                    {completedSteps === 0 ? 'Εκκίνηση Παραμετροποίησης' : completedSteps === totalSteps ? 'Προβολή Παραμετροποίησης' : 'Συνέχεια Παραμετροποίησης'}
                                </Button>
                            </div>
                    ) : (
                            <Alert variant={"secondary"} style={{padding: "10px"}}>
                                <div style={{fontSize: "13px"}}  className="d-flex justify-content-center">
                                    <span className={"fw-bold"} style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Δεν είναι διαθέσιμες οι λειτουργίες παραμετροποίησης σε συσκευή που αναμένεται.</span><br />
                                </div>
                            </Alert>
                    )}
                    <hr style={{marginTop: "0px", marginBottom: "0.3rem"}} />
                    {(!isEmpty(client)) ? (
                        <Row>
                            <Col md={4}>
                                <p className="text-muted mb-0"><i>Στοιχεία Αποστολής:</i></p>
                                <Alert variant={"secondary"}>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>Παραλήπτης:</span>
                                        <span style={{textAlign: 'end'}}>{selectedPos?.shippingDetails?.name}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>Τηλέφωνο Επικοινωνίας:</span>
                                        <span style={{textAlign: 'end'}}>{!isEmpty(selectedPos?.shippingDetails?.phone) ? selectedPos?.shippingDetails?.phone : client?.phone}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>Διεύθυνση Αποστολής:</span>
                                        <span style={{textAlign: 'end'}}>{`${selectedPos?.shippingDetails?.address}, ${selectedPos?.shippingDetails?.postalCode}`}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>Πόλη/Περιοχή:</span>
                                        <span style={{textAlign: 'end'}}>{`${selectedPos?.shippingDetails?.city}, ${selectedPos?.shippingDetails?.state}`}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>ACS Voucher:</span>
                                        <span style={{textAlign: 'end'}}>{`${selectedPos?.shippingData?.acsVoucher || ""}`}
                                            {!isEmpty(selectedPos?.shippingData?.acsMultipartVouchers) && selectedPos?.shippingData?.acsMultipartVouchers?.length > 0 && (
                                                <span>{` (Συνοδευτικά: ${selectedPos.shippingData.acsMultipartVouchers.join(", ")})`}</span>
                                            )}
                                        </span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span className={"fw-bold"} style={{textAlign: 'start'}}>Αναγνωριστικό Λίστας ACS:</span>
                                        <span style={{textAlign: 'end'}}>{`${selectedPos?.shippingData?.acsListId || ""}`}</span>
                                    </div>
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center mt-1">
                                        <Button
                                            style={{padding: "7px"}}
                                            disabled={selectedPos?.status === "available" || trackingLoader}
                                            variant="primary"
                                            onClick={() => openTrackingUrl()}>
                                            {"Εμφάνιση Tracking Αποστολής "}
                                            {trackingLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                        <Button
                                            style={{padding: "7px"}}
                                            variant="primary"
                                            disabled={isEmpty(selectedPos?.shippingData?.acsListId)}
                                            onClick={() => handleOpenAcsList(selectedPos?.shippingData?.acsListId)}>
                                            Εμφάνιση Λίστας Παραλαβής
                                        </Button>
                                    </div>
                                </Alert>
                            </Col>
                            <Col md={5}>
                                <p className="text-muted mb-0"><i>Ενέργειες Αποστολής:</i></p>
                               <Row className={"align-items-center"}>
                                   <Col md={3}>
                                       <DateBox
                                           label={"Ημερομηνία Αποστολής"}
                                           name="shippingDate"
                                           disabled={!isEmpty(selectedPos?.shippingData?.acsVoucher)}
                                           required={true}
                                           minDate={moment().toDate()}
                                           selected={(moment(selectedPos?.shippingDate).isValid() && !isEmpty(selectedPos?.shippingDate)) ? moment(selectedPos?.shippingDate).toDate() : moment().add("1", "day").toDate()}
                                           onChange={(e) => handleOnChange(e, 'dtb', 'shippingDate')}
                                       />
                                   </Col>
                                   <Col md={3}>
                                       <Dropdown
                                           className={"mt-0"}
                                           name={"position"}
                                           label={"Θέση Αρχής Εκτύπωσης"}
                                           required={true}
                                           key={Math.random()}
                                           defaultValue={positionOptions.find((el) => el.value === String(selectedPrintVoucherPosition))}
                                           options={positionOptions}
                                           onChange={(e) => dispatch(setPrimerPosPrintVoucherPosition(e.value))}
                                       />
                                   </Col>
                                   <Col md={3}>
                                       <Button
                                           style={{padding:'10px'}}
                                           className={"mt-4"}
                                           disabled={voucherLoader || !isEmpty(selectedPos?.shippingData?.acsListId) || selectedPos?.status === "waitingStock"}
                                           variant={!isEmpty(selectedPos?.shippingData?.acsVoucher) ? "outline-danger" : "primary"}
                                           onClick={() => {
                                               if(!isEmpty(selectedPos?.shippingData?.acsVoucher)) {
                                                   setDeleteVoucherModal(true);
                                               } else {
                                                   createAcsVoucher();
                                               }
                                           }}>
                                           {!isEmpty(selectedPos?.shippingData?.acsVoucher) ? "Ακύρωση Voucher " : "Δημιουργία και Εκτύπωση Voucher "}
                                           {voucherLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                       </Button>
                                   </Col>
                                   <Col md={3}>
                                       <Button
                                           style={{padding:'10px'}}
                                           className={"mt-4"}
                                           disabled={isEmpty(selectedPos?.shippingData?.acsVoucher) || voucherLoader}
                                           variant={"primary"}
                                           onClick={() => dispatch(setSelectedPrimerPos({...selectedPos, printVoucher: true}))}>
                                           {"Επανεκτύπωση Voucher "}
                                           {voucherLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                       </Button>
                                   </Col>
                               </Row>
                                <Row className={"mt-2"}>
                                    <Col md={6}>
                                        <Input
                                            label={"E-mail Ειδοποίησης"}
                                            className="w-100"
                                            name="email"
                                            type="email"
                                            value={customEmail}
                                            placeholder={"Εισάγετε e-mail Ειδοποίησης"}
                                            onChange={(e) => setCustomEmail(e.target.value)}
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <Button
                                            style={{padding:'10px'}}
                                            disabled={isEmpty(selectedPos?.shippingData?.acsVoucher) || voucherLoader}
                                            className={"mt-4"}
                                            variant="primary"
                                            onClick={() => sendTrackingEmail()}>
                                            {"Επαναποστολή Tracking Email "}
                                            {voucherLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3}>
                                <p className="text-muted mb-0"><i>Αρχείο Καταγραφής Voucher:</i></p>
                                <div style={{ maxHeight: '17vh', overflowY: 'auto', borderBottom: '1px black solid' }}>
                                    <table style={{position: 'sticky', top: "0px", width: "100%"}} className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Ημερομηνία</th>
                                            <th>Ενέργεια</th>
                                            <th>Χρήστης</th>
                                        </tr>
                                        </thead>
                                    </table>
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <tbody>
                                        {(selectedPos?.acsVoucherLogs || [])
                                            .slice()
                                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                                            .map((row, idx) => (
                                                <tr key={`fsHistory-${idx}`}>
                                                    <td>{moment(row.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                                    <td>{row.description}</td>
                                                    <td>{row.user}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <React.Fragment>
                            <p className="text-muted mb-1"><i>Στοιχεία Αποστολής:</i></p>
                            <Alert variant={"secondary"} style={{padding: "10px"}}>
                                <div style={{fontSize: "13px"}}  className="d-flex justify-content-center">
                                    <span className={"fw-bold"} style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Δεν είναι διαθέσιμες οι λειτουργίες Αποστολής σε μη δεσμευμένη συσκευή από πελάτη.</span><br />
                                </div>
                            </Alert>
                        </React.Fragment>
                        )}
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <div style={{flex: 1, justifyContent: 'flex-start'}}>
                    <Button disabled={selectedPos?.status === "shipped" || selectedPos?.status === "arrived" || selectedPos?.status === "waitingStock" || selectedPos?.status === "notAvailable" || selectedPos?.status === "available"} variant="outline-danger" onClick={() => setPosReleaseModal(true)}>Αποδέσμευση Συσκευής</Button>
                    <Button
                        variant={selectedPos?.status === "notAvailable" ? "primary" : "outline-danger"}
                        className={"ml-2"}
                        disabled={selectedPos?.status === "waitingStock"}
                        onClick={() => {
                            if(selectedPos?.status === "notAvailable") {
                                setPosEnableModal(true);
                            } else {
                                setPosRevokeModal(true);
                            }
                        }}>
                        {selectedPos?.status === "notAvailable" ? "Διάθεση Συσκευής" : "Απόσυρση συσκευής"}
                    </Button>

                </div>
                <div style={{justifyContent: 'flex-end'}}>
                    <Button variant="primary" style={{marginRight: "10px"}} onClick={() => setPosLogsModal(true)}>Αρχείο Καταγραφής Ενεργειών</Button>
                    <Button variant="outline-primary" onClick={() => dispatch(setSelectedPrimerPos(null))}>Κλείσιμο</Button>
                </div>
            </Modal.Footer>
        </Modal>
            <PrimerPosConfigurationModal show={primerPosConfigurationModal} setShow={setPrimerPosConfigurationModal} />
            <PrimerPosLogsModal show={posLogsModal} setShow={setPosLogsModal}/>
            <PrimerPosSunmiInfoModal sunmiDeviceInfo={sunmiDeviceInfo} setSunmiDeviceInfo={setSunmiDeviceInfo} onlineStatus={onlineStatus} />
            <UnlockPosModal show={unlockPosModal} setShow={setUnlockPosModal} />
            <PrimerPosVoucherMultipleSerialsModal multiplePos={multiplePos} setMultiplePos={setMultiplePos} createVoucher={(checkMultiple, multipleSerials) => createAcsVoucher(checkMultiple, multipleSerials)} />
            <Modal backdrop={"static"} show={posReleaseModal} onHide={() => setPosReleaseModal(false)}>
                <Modal.Header closeButton style={{textAlign: 'center'}}>
                    <Modal.Title>Αποδέσμευση Συσκευής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 style={{color: 'red'}}>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ!</h4>
                    <hr />
                    Εάν αποδεσμεύσετε την συσκευή όλα τα στοιχεία του συμβολαίου και τα βήματα παραμετροποίησης θα αρχικοποιηθούν!<br />
                    Η κατάσταση της συσκευής θα αλλάξει αυτόματα σε <span style={{fontWeight: 'bold'}}>Διαθέσιμη!</span><br />
                    Είστε σίγουροι ότι θέλετε να αποδεσμεύσετε την συσκευή?
                    <BetterCheckBox
                        name={"disableSimCheckbox"}
                        disabled={isEmpty(selectedPos?.simId)}
                        className={"mt-3 align-content-center"}
                        text={"Απενεργοποίηση Κάρτας SIM"}
                        checked={disableSimCheckbox}
                        onChange={(e) => setDisableSimCheckbox(e.target.checked)}
                    />
                    <hr />
                    <h4 style={{color: 'red'}}>Developer Message:<br />ΜΗΝ ΤΟ ΠΑΤΗΣΕΙΣ ΣΕ ΜΗ ΕΡΓΑΣΙΜΕΣ ΩΡΕΣ!</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={posReleaseLoader} variant="outline-danger" onClick={() => releasePos()}>
                        {"Αποδέσμευση Συσκευής "}
                        {posReleaseLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={deleteVoucherModal} onHide={() => setDeleteVoucherModal(false)}>
                <Modal.Header closeButton style={{textAlign: 'center'}}>
                    <Modal.Title>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Εάν διαγράψετε το τωρινό Acs Voucher θα πρέπει να εκδώσετε καινούργιο και σε περίπτωση που έχει εκτυπωθεί θα πρέπει επίσης να καταστρέψετε το αυτοκόλλητο από την συσκευασία!
                    Είστε σίγουροι ότι θέλετε να ακυρώσετε το συγκεκριμένο Acs Voucher?
                    <hr />
                    <h4 style={{color: 'red'}}>Developer Message:<br />ΜΗΝ ΤΟ ΠΑΤΗΣΕΙΣ ΣΕ ΜΗ ΕΡΓΑΣΙΜΕΣ ΩΡΕΣ!</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={deleteVoucherLoader} variant="outline-danger" onClick={() => deleteAcsVoucher()}>
                        {"Ακύρωση Voucher "}
                        {deleteVoucherLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal backdrop={"static"} show={posRevokeModal} onHide={() => setPosRevokeModal(false)}>
                <Modal.Header closeButton style={{textAlign: 'center'}}>
                    <Modal.Title>Απόσυρση Συσκευής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 style={{color: 'red'}}>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ!</h4>
                    <hr />
                    Εαν αποσύρετε αυτήν την συσκευή τα δεδομένα της συσκευής θα παραμείνουν εώς ότου επαναφέρετε την συσκευή σε διαθέσιμη.
                    Αυτή η ενέργεια είναι μη αντιστρέψιμη!
                    <br />
                    Είστε σίγουροι ότι θέλετε να αποσύρετε την συσκευή?
                    <BetterCheckBox
                        name={"disableSimCheckbox"}
                        disabled={isEmpty(selectedPos?.simId)}
                        className={"mt-3 align-content-center"}
                        text={"Απενεργοποίηση Κάρτας SIM"}
                        checked={disableSimCheckbox}
                        onChange={(e) => setDisableSimCheckbox(e.target.checked)}
                    />
                    <hr />
                    <h4 style={{color: 'red'}}>Developer Message:<br />ΜΗΝ ΤΟ ΠΑΤΗΣΕΙΣ ΣΕ ΜΗ ΕΡΓΑΣΙΜΕΣ ΩΡΕΣ!</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={posRevokeEnableLoader} variant="outline-danger" onClick={() => revokePos()}>
                        {"Απόσυρση Συσκευής "}
                        {posRevokeEnableLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={posEnableModal} onHide={() => setPosEnableModal(false)}>
                <Modal.Header closeButton style={{textAlign: 'center'}}>
                    <Modal.Title>Διάθεση Συσκευής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 style={{color: 'red'}}>ΓΙΓΑΝΤΙΑ ΠΡΟΣΟΧΗ!</h4>
                    <hr />
                    Εάν διαθέσετε εκ νέου την συσκευή όλα τα στοιχεία του συμβολαίου και τα βήματα παραμετροποίησης θα αρχικοποιηθούν και τα στοιχεία πελάτη θα διαγραφούν!
                    Αυτή η ενέργεια είναι μη αντιστρέψιμη!
                    <br />
                    Είστε σίγουροι ότι θέλετε να διαθέσετε την συσκευή?
                    <hr />
                    <h4 style={{color: 'red'}}>Developer Message:<br />ΜΗΝ ΤΟ ΠΑΤΗΣΕΙΣ ΣΕ ΜΗ ΕΡΓΑΣΙΜΕΣ ΩΡΕΣ!</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={posRevokeEnableLoader} variant="primary" onClick={() => enablePos()}>
                        {"Διάθεση Συσκευής "}
                        {posRevokeEnableLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>


        </React.Fragment>
    )
}

export default PrimerPosModal;